import { render, staticRenderFns } from "./CardFormClient.vue?vue&type=template&id=6028cb00&scoped=true"
import script from "./CardFormClient.vue?vue&type=script&lang=js"
export * from "./CardFormClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028cb00",
  null
  
)

export default component.exports